import Common from "../../../../Common";

const Available = class extends Common {
	browse = () => this.get('/teams/presence/profile/available')
}

export default Available;
